import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Container, Box, TextField, Button, Typography, Paper, Alert } from '@mui/material';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { token, setToken } = useAuth();
  const [otp, setOtp] = useState('');
  const [otpRequested, setOtpRequested] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const nav = useNavigate();

  if (token) return <Navigate to="/dashboard" replace />;
  const base = process.env.REACT_APP_API_BASE_URL || 'http://localhost:7777';

  async function requestOTP() {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${base}/auth/request-otp`, { method: 'POST' });
      const data = await res.json();
      if (res.ok) {
        setOtpRequested(true);
      } else {
        setError(data.error || 'Failed to send OTP');
      }
    } catch (e) {
      setError('Failed to send OTP');
    } finally {
      setLoading(false);
    }
  }

  async function verifyOTP(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${base}/auth/verify-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ otp: otp.trim() }),
      });
      const data = await res.json();
      if (res.ok && data.token) {
        setToken(data.token);
        nav('/dashboard');
      } else {
        setError(data.error || 'Invalid OTP');
      }
    } catch (e) {
      setError('Failed to verify OTP');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 4, sm: 8 }, px: { xs: 1.5 } }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>Login</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Box component="form" onSubmit={verifyOTP}>
          {!otpRequested ? (
            <Button fullWidth variant="contained" onClick={requestOTP} disabled={loading} size="large" sx={{ mt: 2 }}>
              {loading ? 'Sending...' : 'Request OTP'}
            </Button>
          ) : (
            <>
              <TextField
                fullWidth
                label="Enter OTP"
                margin="normal"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                inputProps={{ maxLength: 6, inputMode: 'numeric', pattern: '[0-9]*' }}
              />
              <Button type="submit" fullWidth variant="contained" disabled={loading || !otp.trim()} size="large" sx={{ mt: 2 }}>
                {loading ? 'Verifying...' : 'Verify OTP'}
              </Button>
              <Button fullWidth variant="text" onClick={() => { setOtpRequested(false); setOtp(''); }} sx={{ mt: 1 }}>
                Request New OTP
              </Button>
            </>
          )}
        </Box>
      </Paper>
    </Container>
  );
}


